import Plotly from 'plotly.js-basic-dist-min';
import createPlotlyComponent from "react-plotly.js/factory";
import {getScatterData} from "../assets/utils";

const LPLOT = ({title, dataString, width, height}) => {
    const Plot = createPlotlyComponent(Plotly);
    let [plotData, numCategories] = getScatterData(dataString, 0, 3, 2)

    let graphWidth = window.innerWidth * width
    let graphHeight = width * window.innerHeight * 1.5
    let legendX

    if (graphWidth < 350) {
        graphWidth = 350
    }

    if (graphHeight < 400) {
        graphHeight = 400
    }

    if (graphHeight > 800) {
        graphHeight = 800
    }

    if (graphHeight < 500) {
        legendX = -1.3 * numCategories / 10
    } else if (graphHeight < 600) {
        legendX = -0.7 * numCategories / 10
    } else {
        legendX = -0.5 * numCategories / 10
    }

    return (
        <>
            <Plot data={plotData}
                  layout={{
                      font: {
                          family: 'Arial'
                      },
                      title: {
                          text: title,
                          font: {
                              size: Math.min(39 * width, 20),
                          },
                          xref: 'paper',
                          x: -0.5,
                      },
                      showlegend: true,
                      legend: {
                          x: 0,
                          y: legendX,
                      },

                      width: graphWidth,
                      height: graphHeight + 200,

                      yaxis: {
                          title: {
                              text: 'Publication Count',
                              font: {
                                  size: 18,
                                  color: '#7f7f7f'
                              }
                          }
                      }
                  }}/>
        </>
    );
}

export default LPLOT;